import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1497007874735639';
type PixelFunction = {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || window.fbq) return;
    const fbq = ((...args: unknown[]) => {
      fbq.queue.push(args);
    }) as PixelFunction;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', PIXEL_ID);
    fbq('track', 'PageView');
  }, []);
  return null;
}